module.exports = __webpack_public_path__ + "img/zphd_xzg_s2.df6b1374.png";